import { render, staticRenderFns } from "./TipoNomina.vue?vue&type=template&id=3d049228&scoped=true"
import script from "./TipoNomina.vue?vue&type=script&lang=js"
export * from "./TipoNomina.vue?vue&type=script&lang=js"
import style0 from "./TipoNomina.vue?vue&type=style&index=0&id=3d049228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d049228",
  null
  
)

export default component.exports